import { MarketplaceListing } from '@/types/residents/marketplaceListing';
import type { MarketplaceCategory } from './MarketplaceCategoryFilter';

const CATEGORY_KEYWORDS: Record<string, string[]> = {
  Furniture: ['desk', 'chair', 'table', 'sofa', 'couch', 'shelf', 'bookshelf', 'bed', 'dresser', 'lamp', 'cabinet', 'furniture'],
  Electronics: ['headphone', 'phone', 'laptop', 'computer', 'tv', 'monitor', 'speaker', 'camera', 'tablet', 'electronic', 'wireless'],
  Clothing: ['shirt', 'pants', 'jacket', 'shoes', 'dress', 'clothing', 'hat', 'coat', 'sweater', 'jeans'],
};

export function filterMarketplaceListings(
  listings: MarketplaceListing[],
  category: MarketplaceCategory,
  searchQuery: string,
): MarketplaceListing[] {
  let filtered = listings;

  if (category === 'Free') {
    filtered = filtered.filter((l) => l.priceValue === 0);
  } else if (category !== 'All') {
    const keywords = CATEGORY_KEYWORDS[category] ?? [];
    filtered = filtered.filter((l) => {
      const text = `${l.title} ${l.description}`.toLowerCase();
      return keywords.some((kw) => text.includes(kw));
    });
  }

  if (searchQuery.trim()) {
    const query = searchQuery.trim().toLowerCase();
    filtered = filtered.filter((l) => {
      const text = `${l.title} ${l.description}`.toLowerCase();
      return text.includes(query);
    });
  }

  return filtered;
}
